import { render } from "./InstallationSuccess.vue?vue&type=template&id=030af86b&scoped=true"
import script from "./InstallationSuccess.vue?vue&type=script&lang=js"
export * from "./InstallationSuccess.vue?vue&type=script&lang=js"

import "./InstallationSuccess.vue?vue&type=style&index=0&id=030af86b&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-030af86b"]])

export default __exports__